export default {
    list: {
        title: "公告中心",
        desc: "查看剑网3魔盒的最新动态、运营活动、功能更新与兑换通知。",
        searchPlaceholder: "请输入关键词搜索",
        sticky: "置顶",
        empty: "当前分类暂无公告内容",
        jump: "跳转",
        authorDefault: "魔盒",
        tabs: {
            all: "全部",
            notice: "公告动态",
            information: "运营活动",
            feature: "功能更新",
            message: "兑换通知",
        },
    },
    single: {
        back: "返回列表",
        lastUpdated: "最后更新：{date}",
        views: "{count} 阅读",
        edit: "编辑",
        manage: "管理",
        like: "点赞 ({count})",
        star: "收藏",
        starred: "已收藏",
        comments: "评论",
        commentsClosed: "当前公告未开启评论功能",
        visibilityTip: "作者设置了【{visibility}】",
        visibility: {
            public: "公开",
            self: "仅自己可见",
            friends: "仅亲友可见",
            password: "密码可见",
            paid: "付费可见",
            fans: "粉丝可见",
        },
    },
};
